
import { Injectable, NgModule} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { of, Observable, throwError, } from 'rxjs';
import { map, catchError} from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material';


/*
  Intercepts the HttpClient
  to configure headers
*/
@Injectable()
export class GlobalInterceptor implements HttpInterceptor {


  returnUrl: any;

  constructor(public snackBar: MatSnackBar, public router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token: string  = localStorage.getItem('token');




    if ((!request.url.includes('login') || !request.url.includes('registration') ) && token) {
    request = request.clone({headers: request.headers.set('Authorization', 'Token ' + token)});
    }

    if (!request.headers.has('Content-Type')) {
    request = request.clone({headers: request.headers.set('Content-Type', 'application/json')});
    }




    return next.handle(request).pipe(

      map((event: HttpEvent<any>) => {

        if (event instanceof HttpResponse) {
          console.log('event--->>>', event);
        }
        return event;

      }
      ) ,

      catchError((error: HttpErrorResponse) => {
        console.log(error);
        if (error.status === 403 &&
          ((error.error.detail.toString()).includes('Invalid token')
            || (error.error.detail.toString()).includes('Authentication credentials were not provided'))) {


          localStorage.removeItem('token');
          this.snackBar.open('Sesión inválida. Regresando a la página de inicio.', null, {
            duration: 3000
          });

          this.router.navigate(['/']);

        }

        return throwError(error);
    })



    );



  }
}

